import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Notification, Response } from '../models';
import { ToastService } from './toast.service';
import { ObservableService } from './observable.service';

@Injectable({providedIn: 'root'})
export class NotificationService {

  constructor(
    private http: HttpClient,
    private toastService: ToastService,
    private observableService: ObservableService) { }

  getNotifications(max_elements : number | null = null): Promise<{ notification_item_recent: Notification[], notification_item_older: Notification[] }> {
    const path = max_elements? `Notification-GetNotifications/${max_elements}` : 'Notification-GetNotifications';
    return this.http.get<
    { notification_item_recent: Notification[], notification_item_older: Notification[] }
    >(`${environment.apiUrl}/${path}`).toPromise();
  }

  getNotificationsExecutionCompleted(): Promise<{ notification_item_recent: Notification[], notification_item_older: Notification[] }> {
    return this.http.get<
    { notification_item_recent: Notification[], notification_item_older: Notification[] }
    >(`${environment.apiUrl}/Notification-GetNotificationsExecutionCompleted`).toPromise();
  }

  setReadNotification(idNotification: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/Notification-SetReadNotification`,
      {
        id_notification: idNotification
      }
    ).toPromise();
  }

  setAllNotificationAsRead(): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/Notification-SetALLNotificationAsRead`,
      {},
    ).toPromise();
  }

  async intervalUpdateExecutionStatus(canSendObservable: boolean) {
    try {
      const notificationsList = (await this.getNotificationsExecutionCompleted()).notification_item_recent;
      if (notificationsList.length > 0) {
        notificationsList.map(notification => {
          this.toastService.showSuccess({
            description: notification.description,
            type: 'success'
          });
          this.setReadNotification(notification.id_notification);
          if (canSendObservable) {
            this.observableService.updateStatusExecution('updateExecution');
          }
          this.observableService.updateNotifications('updateNotifications');
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
}
